import { ComponentProps } from 'react'

import { formatDateWithDayOfWeek } from '@/shared/lib'

import { useContract } from './provider'
import { DIALOG } from '../../../lib/contract-dialog'

const DATE_FORMAT = 'yyyy.MM.dd'

type TriggerProps = Omit<ComponentProps<'button'>, 'color'>

export const PeriodButton = (props: TriggerProps) => {
  const { period, getLastActiveContract, openDialog } = useContract()

  const handleClick = async () => {
    const { success, data: contract } = await getLastActiveContract()

    if (!success) {
      return
    }

    if (contract?.isExtendContractAvailable) {
      // 확정된 계약이 있는 경우 (연장 가능한 경우)
      openDialog(DIALOG.CHECK_EXTEND_CONTRACT)
    } else {
      // 확정된 계약이 없는 경우
      openDialog(DIALOG.PERIOD_CALENDAR)
    }
  }

  if (!period?.from || !period?.to) {
    return null
  }

  return (
    <button
      type="button"
      className="w-full cursor-pointer rounded-sm bg-white px-6 py-3 text-start shadow-[0px_1px_4px_0px_rgba(0,0,0,0.10)] not-last:mb-6"
      {...props}
      onClick={handleClick}
    >
      <dl className="flex items-center gap-5">
        <div className="w-25 space-y-1">
          <dt className="typo-label2 font-normal text-gray-500">입주일</dt>
          <dd className="typo-label1 font-medium text-black">
            {formatDateWithDayOfWeek({
              date: period.from,
              format: DATE_FORMAT,
            })}
          </dd>
        </div>
        <div className="h-px w-2 shrink-0 translate-y-3 bg-black" />
        <div className="w-25 space-y-1">
          <dt className="typo-label2 font-normal text-gray-500">퇴실일</dt>
          <dd className="typo-label1 font-medium text-black">
            {formatDateWithDayOfWeek({
              date: period.to,
              format: DATE_FORMAT,
            })}
          </dd>
        </div>
      </dl>
    </button>
  )
}
